import { render } from "./WorkshopCard.vue?vue&type=template&id=ee7420ba&scoped=true"
import script from "./WorkshopCard.vue?vue&type=script&lang=js"
export * from "./WorkshopCard.vue?vue&type=script&lang=js"

import "./WorkshopCard.vue?vue&type=style&index=0&id=ee7420ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee7420ba"]])

export default __exports__